export function tabPanelConfig({ colors }) {
    return {
        background: colors.background.tabPanelBackground
    };
}
